import { render, staticRenderFns } from "./menu-pages.vue?vue&type=template&id=60f9165d&scoped=true&lang=pug"
import script from "./menu-pages.vue?vue&type=script&lang=ts"
export * from "./menu-pages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f9165d",
  null
  
)

export default component.exports